<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺别名">
                  <el-select v-model="queryForm.vendorAliasId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.vendorNameAlias" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="品牌">
                  <el-select v-model="queryForm.brandId" filterable clearable>
                    <el-option v-for="item in brandList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="国家">
                  <el-select v-model="queryForm.addressCountryId" filterable clearable style="width: 100%">
                    <el-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div>
      <el-button type="primary" @click="showForm">新增配置</el-button>
    </div>
    <el-table :data="tableData" v-loading="loading">
      <el-table-column prop="vendorId" label="店铺ID"></el-table-column>
      <el-table-column prop="vendorName" label="店铺名字">
        <template slot-scope="scope">
          {{ scope.row.vendorName }}
          <p>/</p>
          {{ scope.row.vendorNameAlias }}
        </template>
      </el-table-column>
      <el-table-column prop="brandName" label="品牌"></el-table-column>
      <el-table-column prop="reptileType" label="店铺属性">
        <template slot-scope="scope">
          <span v-if="scope.row.reptileType === 1">柜台店</span>
          <span v-if="scope.row.reptileType === 2">买手公司</span>
        </template>
      </el-table-column>
      <el-table-column prop="addressCountry" label="国家"></el-table-column>
      <el-table-column prop="vendorSerialNumber" label="序号"></el-table-column>
      <el-table-column prop="parentVendorId" label="对应爬虫店铺">
        <template slot-scope="scope">
          {{ reptileVendorNameMap[scope.row.parentVendorId] }}
          <p>/</p>
          {{ reptileVendorAliasMap[scope.row.parentVendorId] }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="editItem(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="removeItem(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="form.vendorCounterBrandRelationId ? '编辑' : '新增 '" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item prop="vendorId" label="买手店" :rules="[{ required: true, message: '请选择买手店' }]">
          <el-select v-model="form.vendorId" filterable :disabled="Boolean(form.vendorCounterBrandRelationId)">
            <el-option v-for="item in vendorList" :label="`${item.vendorNameAlias} - ${item.label}`" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="brandId" label="品牌" :rules="[{ required: true, message: '请选择品牌' }]">
          <el-select v-model="form.brandId" filterable>
            <el-option v-for="item in brandList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="addressCountryId" label="国家" :rules="[{ required: true, message: '请选择国家' }]">
          <el-select v-model="form.addressCountryId" filterable style="width: 100%">
            <el-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="reptileType" label="店铺属性" :rules="[{ required: true, message: '请选择店铺属性' }]">
          <el-select v-model="form.reptileType" filterable>
            <el-option label="柜台店" :value="1"></el-option>
            <el-option label="买手公司" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="vendorSerialNumber" label="序号" :rules="[{ required: true, message: '请输入序号' }]">
          <el-input v-model="form.vendorSerialNumber"></el-input>
        </el-form-item>
        <el-form-item prop="parentVendorId" label="对应爬虫店铺" :rules="[{ required: true, message: '请选择对应爬虫店铺' }]">
          <el-select v-model="form.parentVendorId" filterable>
            <el-option v-for="item in reptileVendorList" :label="`${item.vendorNameAlias} - ${item.label}`" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVendorWithBrandList,
  batchAddOrUpdateVendorCounter,
  updateVendorCounter,
  delVendorCounterByIds,
  getReptileVendorList,
} from "../../api/merchants";
import {
  getBrandList,
  getVendorList,
} from '../seller/api';
import {
  getCountryList,
} from '../buyershop/api';

export default {
  data() {
    return {
      fullscreenLoading: false,
      brandList: [],
      vendorList: [],
      vendorNameMap: {},
      vendorAliasMap: {},
      reptileVendorList: [],
      reptileVendorNameMap: {},
      reptileVendorAliasMap: {},
      countryList: [],
      queryForm: {
        brandId: null,
        vendorAliasId: null,
        vendorId: null,
        addressCountryId: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      form: {
        vendorCounterBrandRelationId: null,
        vendorId: null,
        brandId: null,
        addressCountryId: null,
        reptileType: null,
        vendorSerialNumber: null,
        parentVendorId: null,
      },
    };
  },
  created() {
    getBrandList().then(res => {
      this.brandList = (res.data || []).map(item => ({
        label: item.englishName,
        value: item.brandId
      }));
    });
    getVendorList(true).then(res => {
      if (res.data) {
        const vendorAliasMap = {};
        const vendorNameMap = {};
        this.vendorList = res.data.map(item => {
          vendorAliasMap[item.vendorId] = item.vendorNameAlias;
          vendorNameMap[item.vendorId] = item.vendorName;
          return {
            value: item.vendorId,
            label: item.vendorName,
            vendorNameAlias: item.vendorNameAlias,
          }
        })
        this.vendorAliasMap = vendorAliasMap;
        this.vendorNameMap = vendorNameMap;
      }
    })
    getReptileVendorList().then(res => {
      if (res.data) {
        const reptileVendorAliasMap = {};
        const reptileVendorNameMap = {};
        this.reptileVendorList = res.data.map(item => {
          reptileVendorAliasMap[item.vendorId] = item.vendorNameAlias;
          reptileVendorNameMap[item.vendorId] = item.vendorName;
          return {
            value: item.vendorId,
            label: item.vendorName,
            vendorNameAlias: item.vendorNameAlias,
          }
        })
        this.reptileVendorAliasMap = reptileVendorAliasMap;
        this.reptileVendorNameMap = reptileVendorNameMap;
      }
    })
    getCountryList().then(res=>{
      this.countryList = (res.data.data || []).map(item => {
        return {
          value: item.addressCountryId,
          label: item.name
        }
      })
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.brandId = null;
      this.queryForm.vendorAliasId = null;
      this.queryForm.vendorId = null;
      this.queryForm.addressCountryId = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getVendorWithBrandList({
        ...this.queryForm,
        vendorId: this.queryForm.vendorAliasId || this.queryForm.vendorId,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list || [];
        }
        this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    showForm() {
      this.form.vendorCounterBrandRelationId = null;
      this.form.vendorId = null;
      this.form.brandId = null;
      this.form.addressCountryId = null;
      this.form.reptileType = null;
      this.form.vendorSerialNumber = null;
      this.form.parentVendorId = null;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    editItem(row) {
      this.form.vendorCounterBrandRelationId = row.vendorCounterBrandRelationId;
      this.form.vendorId = row.vendorId;
      this.form.brandId = row.brandId;
      this.form.addressCountryId = row.addressCountryId;
      this.form.reptileType = row.reptileType;
      this.form.vendorSerialNumber = row.vendorSerialNumber;
      this.form.parentVendorId = row.parentVendorId;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = [this.form];
          let request = batchAddOrUpdateVendorCounter;
          if (this.form.vendorCounterBrandRelationId) {
            request = updateVendorCounter;
            data = this.form;
          }
          request(data).then(res => {
            if (res.data.success) {
              this.dialogVisible = false;
              this.$message.success('操作成功');
              this.getTableData();
            } else {
              this.$message.error(res.data.message || '系统异常');
            }
          })
        }
      })
    },
    removeItem(row) {
      this.$confirm(`确认删除${row.vendorName}-${row.brandName}吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delVendorCounterByIds({
          ids: row.vendorCounterBrandRelationId
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.getTableData();
        })
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.ml10 {
  margin-left: 10px;
}
</style>
